// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Anbauteil } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAnbauteil(): (anbauteilId: string) => Promise<Anbauteil> {
  const getAPI = useGetApi();
  return useCallback(
    async (anbauteilId) =>
      (await getAPI()).anbauteile.getAnbauteil({ anbauteilId }),
    [getAPI]
  );
}
